import React, { useEffect, useState } from "react";
import { HomePageContainer } from "./HomePageContainer";
import Slider from "react-slick";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import usePartnerList from "../../Hooks/usePartnerList";
import img1 from "../../assets/images/herosection.png";
import img2 from "../../assets/images/herosection.png";
import img3 from "../../assets/images/herosection.png";
import { axiosFunction } from "../../axiosFunction";
import { smaartCardUrl } from "../../constant";
import defaultPhoto from "../../assets/images/imagePlaceholder.png";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import mailBoxImg from "../../assets/images/mailBox.png";
import blogImg from "../../assets/images/blogImg.jpg";
import { FaArrowRightLong, FaHeart, FaRegHeart } from "react-icons/fa6";
import Loader from "../../components/Loader/Loader";
import { toastMessage } from "../../utils/toastUtils";
import { emailRegex } from "../../utils/EmailRegex";
import Accordian from "../../components/Accordian/Accordian";
import { swalUtils } from "../../utils/swalUtils";
import { useRazorpay } from "react-razorpay";
import useResponsive from "../../Hooks/useResponsive";
import { SvgIcon } from "../../components/SvgIcon/SvgIcon.jsx";
import { useGeneralSetting } from "../../Hooks/useGeneralSetting";
import { setUserData } from "../../store/User/UserSlice";
import banner1 from "../../assets/bannerImages/banner1.jpg";
import banner2 from "../../assets/bannerImages/banner2.jpg";
import banner3 from "../../assets/bannerImages/banner3.jpg";
import banner4 from "../../assets/bannerImages/banner4.jpg";
import defaultBlogImg from "../../assets/images/smartCard.jpg"
// import defaultBlogImg from "../../assets/blogImages/blog1.jpg"
import OffersList from "../../components/OfferList/Offers";

const HomePage = () => {
  const { Razorpay } = useRazorpay();

  const [emailSub, setEmailSub] = useState("");
  const [emailFranch, setEmailFranch] = useState("");
  const [subscriptionExpired, setSubscriptionExpired] = useState(false);
  const [checkingSubscription, setCheckingSubscription] = useState(true);
  const [blogList, setBlogList] = useState([]);
  const [loadingBlogs, setLoadingBlogs] = useState(false);
  console.log("blogList", blogList);
  const cityName = localStorage.getItem("partnerCity") || "";
  const userId = localStorage.getItem("userId") || 0;
  const { getPartnerList, loadingPartners } = usePartnerList();
  const partnerList = useSelector((state) => state.partnerList);
  const userData = useSelector((state) => state.userData);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const offerId = localStorage.getItem("offerId") || 0;

  const [showMoreCategory, setShowMoreCategory] = useState(false);
  const [hover, setHover] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [subscriptionList, setSubscriptionList] = useState([]);

  const [faqData, setFaqData] = useState([]);

  const [currentSlide, setCurrentSlide] = useState(1);

  const [bannerArr, setBannerArr] = useState([]);

  const { isMobile, isRespon } = useResponsive();

  const { getGeneralSetting } = useGeneralSetting();

  const checkSubscriptionExpiration = async () => {
    try {
      const patientId = localStorage.getItem("userId");

      // If no user is logged in, no need to check
      if (!patientId) {
        setCheckingSubscription(false);
        return;
      }

      const response = await axiosFunction(
        `${smaartCardUrl}/api/v1/dfordr/user/checkIsExpired?patientId=${patientId}`,
        "GET",
        null
      );

      // Check if response is true (expired)
      console.log("Subscription expiration response:", response?.data?.status);

      if (response?.data.response === "true" || response?.data.response === true) {
        setSubscriptionExpired(true);
      } else {
        // Handle other cases (like null, undefined, or different response structure)
        setSubscriptionExpired(false);
      }
    } catch (error) {
      console.error("Error checking subscription status:", error);
      // Don't show error to user, just assume not expired
      setSubscriptionExpired(false);
    } finally {
      setCheckingSubscription(false);
    }
  };

  // Fetch blog posts function defined before useEffect to avoid hoisting issues
  const fetchBlogPosts = async () => {
    setLoadingBlogs(true);
    try {
      const response = await fetch(
        "https://blog.smaartcard.com/wp-json/wp/v2/posts?per_page=6&_embed"
      );
      console.log("Blog API Response Status:", response.status);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const posts = await response.json();

      // Transform WordPress posts to match your blogList structure
      const formattedPosts = posts.map((post) => {
        // Get featured image if available
        const featuredImage =
          post._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
          defaultBlogImg;

        // Extract excerpt/description
        const excerpt = post.excerpt?.rendered
          ? post.excerpt.rendered.replace(/<[^>]*>/g, "").substring(0, 150) + "..."
          : post.content?.rendered
          ? post.content.rendered.replace(/<[^>]*>/g, "").substring(0, 150) + "..."
          : "";

        return {
          blogId: post.id,
          blogImg: featuredImage,
          blogLink: post.link,
          blogTitle: post.title.rendered,
          blogSubtitle: excerpt,
        };
      });

      setBlogList(formattedPosts);
    } catch (error) {
      console.error("Error fetching blog posts:", error);
      toastMessage("Failed to load blog posts", "error");
      setBlogList([]);
    } finally {
      setLoadingBlogs(false);
    }
  };

  useEffect(() => {
    getGeneralSetting();
    checkSubscriptionExpiration();
    fetchBlogPosts(); // Now safely defined
  }, []);

  useEffect(() => {
    const faqDetails = async () => {
      const faqRes = await axiosFunction(
        `${smaartCardUrl}/api/v1/dfordr/faq/getall`,
        "GET",
        null
      );

      if (faqRes?.data?.status) {
        setFaqData(faqRes?.data?.response?.FaqVo);
      } else {
        setFaqData([]);
      }
    };

    faqDetails();
  }, []);

  useEffect(() => {
    const getCategoryList = async () => {
      const catRes = await axiosFunction(
        `${smaartCardUrl}/api/v1/dfordr/master/categories/fetchall`,
        "GET",
        null
      );

      if (catRes?.data?.status) {
        setCategoryList(catRes?.data?.response);
      } else {
        setCategoryList([]);
      }
    };

    getCategoryList();
  }, []);

  useEffect(() => {
    getPartnerList(0, 1000, cityName, 0, offerId, userId);
  }, []);

  useEffect(() => {
    const getSubscriptionList = async () => {
      const res = await axiosFunction(
        `${smaartCardUrl}/api/v1/dfordr/master/subcription/fetchall`,
        "GET",
        null
      );

      if (res?.data?.status) {
        setSubscriptionList(res?.data?.response);
      } else {
        setSubscriptionList([]);
      }
    };

    getSubscriptionList();
  }, []);

  // Banner dynamic.
  useEffect(() => {
    const getBannerList = async () => {
      const res = await axiosFunction(
        `${smaartCardUrl}/api/v1/banner/getAllBanners`,
        "GET",
        null
      );

      if (res?.data?.status) {
        setBannerArr(res?.data?.response);
      } else {
        setBannerArr([]);
      }
    };

    getBannerList();
  }, []);

  const bannerFilterArr = bannerArr?.filter(
    (banner) => banner?.isActive === 1 && banner?.isDeleted === 0
  );

  const sliderSettings = {
    slidesToShow: isMobile && isRespon ? 1 : 1.65,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    speed: 500,
    infinite: true,
    autoplaySpeed: 2000,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const [expandedCards, setExpandedCards] = useState({});

  const toggleExpand = (cardId) => {
    setExpandedCards(prev => ({
      ...prev,
      [cardId]: !prev[cardId]
    }));
  };

  const subscribeSliderSettings = {
    slidesToShow:
      isMobile && isRespon
        ? 1
        : Math.min(
          3,
          subscriptionList?.filter((sub) => sub.isActive === 0).length
        ),
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    speed: 500,
    infinite: subscriptionList?.filter((sub) => sub.isActive === 0).length >= 3,
    autoplaySpeed: 2000,
    autoplay: true,
    beforeChange: (current, next) => {
      const inactiveSubscriptions = subscriptionList?.filter(
        (sub) => sub.isActive === 0
      );

      const totalSlides = inactiveSubscriptions.length;
      const middleIndex = (next + Math.floor((3 - 1) / 2)) % totalSlides;
      setCurrentSlide(isMobile && isRespon ? next : middleIndex);
    },
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleShowCategory = () => {
    setShowMoreCategory(!showMoreCategory);
  };

  const handleCardClick = (categoryObj) => {
    localStorage.setItem("category", categoryObj?.typeName);
    const formattedTypeName = categoryObj?.typeName?.replace(/ /g, "_");
    navigate(`/category/${formattedTypeName}/${categoryObj?.categoryMasterId}`);
  };

  const handlePartnerClick = (partnerObj) => {
    const partnerName = partnerObj?.partnerName
      .split(" ")
      .join("_")
      .toLowerCase();
    navigate(`/partner/${partnerName}/${partnerObj?.partnerId}`);
  };

  const handleEmailFranchise = async () => {
    navigate("/partnerforbusiness");
  };

  const handleSubscribe = async (obj) => {
    const buyNowSwal = await swalUtils(
      "Buy Now",
      `Subscription Name: ${obj?.name}`,
      `Buy now ₹${obj?.price}`,
      "Cancel"
    );

    if (buyNowSwal?.isConfirmed) {
      if (!localStorage.getItem("userId")) {
        navigate("/login");
        return;
      } else {
        const paymentPayload = {
          patientId: userData.patientId,
          subscriptionId: obj?.subscriptionMasterId,
          amount: obj?.price * 100,
          price: obj?.price,
        };

        const paymentRes = await axiosFunction(
          `${smaartCardUrl}/api/v1/payment/create`,
          "POST",
          paymentPayload
        );

        if (paymentRes?.data?.status) {
          const options = {
            key: paymentRes?.data?.response.keyId,
            amount: obj?.price,
            currency: "INR",
            name: userData?.name,
            description: `Subscription Name: ${obj?.name}`,
            image: obj?.img,
            order_id: paymentRes?.data?.response?.orderId,
            handler: async function (paymentResponse) {
              const paymentPayload = {
                paymentId: paymentRes?.data?.response?.paymentId,
                razorpayPaymentId: paymentResponse?.razorpay_payment_id,
                razorpayOrderId: paymentResponse?.razorpay_order_id,
                razorpaySignature: paymentResponse?.razorpay_signature,
                status: "success",
              };
              const razorPayRes = await axiosFunction(
                `${smaartCardUrl}/api/v1/payment/update`,
                "POST",
                paymentPayload
              );

              if (razorPayRes?.data?.status) {
                setSubscriptionExpired(true);
                const profileRes = await axiosFunction(
                  `${smaartCardUrl}/api/v1/dfordr/user/${localStorage.getItem(
                    "userId"
                  )}`,
                  "GET",
                  null
                );

                if (profileRes?.data?.status) {
                  dispatch(setUserData(profileRes?.data?.response));
                }

                // Re-check subscription status after successful payment
                await checkSubscriptionExpiration();

                toastMessage("Payment Successful!", "success");
              } else {
                toastMessage("Payment Failed!", "error");
              }
            },
            prefill: {
              name: userData?.patientName,
              email: userData?.email,
            },
            theme: {
              color: "#3085d6",
              MaxHeight: "70%",
            },
            modal: {
              ondismiss: function () {
                return true;
              },
            },
          };

          const rzp = new Razorpay(options);
          rzp.open();
          rzp.on("payment.failed", async function (response) {
            try {
              const payload = {
                paymentId: paymentRes?.data?.response?.paymentId,
                status: "failed",
                code: response.error.code,
                reason: response.error.reason,
              };
              const razorPayRes = await axiosFunction(
                `${smaartCardUrl}/api/v1/payment/update`,
                "POST",
                payload
              );

              if (razorPayRes?.data?.status) {
                toastMessage("Payment Failed!", "error");
              }
            } catch (error) {
              console.error("Payment failure error:", error);
            }
          });
        } else {
          toastMessage(paymentRes?.data?.message, "error");
        }
      }
    }
  };

  const toggleFavorite = async (partner, e) => {
    e.stopPropagation();

    if (!localStorage.getItem("userId")) {
      navigate("/login");
      return;
    }

    try {
      let response;
      if (partner.isFavourite === 1) {
        response = await axiosFunction(
          `${smaartCardUrl}/api/v1/dfordr/user/deleteFavouritePartner?userId=${userData.patientId}&partnerId=${partner.partnerId}`,
          "DELETE",
          ""
        );
      } else {
        response = await axiosFunction(
          `${smaartCardUrl}/api/v1/dfordr/user/addFavouritePartner?userId=${userData.patientId}&partnerId=${partner.partnerId}`,
          "POST",
          ""
        );
      }

      if (response?.data?.status) {
        getPartnerList(0, 1000, cityName, 0, offerId, userId);
        toastMessage(response?.data?.message, "success");
      } else {
        toastMessage(response?.data?.message || "Operation failed", "error");
      }
    } catch (error) {
      console.error("Error toggling favorite:", error);
      toastMessage("An error occurred", "error");
    }
  };

  if (loadingPartners || checkingSubscription) {
    return <Loader />;
  }

  return (
    <HomePageContainer>
      <Header />
      {/* Subscription Expired Warning Banner */}
      {subscriptionExpired && (
        <div
          style={{
            width: '100%',
            backgroundColor: '#ff6e6eff',
            color: 'white',
            padding: '16px',
            textAlign: 'center',
            fontWeight: 'bold',
            fontSize: '18px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            position: 'fixed',
            top: 110,
            left: 0,
            zIndex: 1000,
          }}
        >
          ⚠️ Your subscription has expired. Please renew to continue accessing all features.
        </div>
      )}

      <div className={`mt-4 mb-4 ${subscriptionExpired ? 'mt-5' : ''}`}>
        <Slider {...sliderSettings}>
          {bannerFilterArr.map((banner) => (
            <div key={banner.bannerId}>
              <img
                src={banner.bannerImg}
                alt={`Banner ${banner.bannerId}`}
                className="imgSlider img-fluid"
                style={{ cursor: banner.bannerLink ? 'pointer' : 'default' }}
                onClick={() => {
                  if (banner.bannerLink) {
                    window.open(banner.bannerLink, '_blank');
                  }
                }}
              />
            </div>
          ))}
        </Slider>
      </div>

      <div className="allContent">
        {categoryList?.length > 0 && (
          <div className="msection">
            <Container>
              <Row>
                <Col xs={12}>
                  <div className="sectionMainTitle">
                    <span className="sectionTitle">Category</span>
                  </div>
                </Col>
              </Row>
              <div className="partner-content">
                <Row>
                  {categoryList
                    ?.map((categoryObj) => {
                      return (
                        <Col
                          key={categoryObj?.partnerId}
                          md={3}
                          xs={6}
                          className="mt-2"
                        >
                          <Card
                            style={{ cursor: "pointer", height: "100%" }}
                            onClick={() => handleCardClick(categoryObj)}
                            className="partnerMainCard"
                          >
                            <Card.Body className="partnerCardContent">
                              <div className="partnerImgSection">
                                <img
                                  className="img-fluid"
                                  src={categoryObj?.categoryImg || defaultPhoto}
                                  alt="google_store_img"
                                />
                              </div>
                              <div className="productSectionTitle mt-lg-2">
                                {categoryObj?.typeName}
                              </div>
                            </Card.Body>
                          </Card>
                        </Col>
                      );
                    })
                    .slice(0, showMoreCategory ? categoryList.length : 8)}
                </Row>
              </div>
              <div
                onClick={handleShowCategory}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <span
                  style={{
                    color: "#ffffff",
                    marginTop: "10px",
                    padding: "10px 24px",
                    borderRadius: "30px",
                    fontWeight: 600,
                    background: "#024089",
                    fontSize: "18px",
                    letterSpacing: "0.5px",
                    userSelect: "none",
                    textAlign: "center",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  }}
                >
                  {showMoreCategory ? "Show Less" : "Show More"}
                </span>
              </div>
            </Container>
          </div>
        )}

        {subscriptionList?.filter((sub) => sub.isActive === 0).length > 0 && (
          <div className="msection" style={{ background: "#f0f7ff" }}>
            <Container>
              <Row>
                <Col xs={12}>
                  <div className="sectionMainTitle">
                    <span className="sectionTitle">Subscription Details</span>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="mt-3 mb-3 subs">
                  <Slider {...subscribeSliderSettings}>
                    {subscriptionList
                      ?.filter((sub) => sub.isActive === 0)
                      .map((subObj, index) => {
                        { console.log("Current Slide Index:", subObj); }
                        return (
                          <Card
                            key={subObj?.subscriptionMasterId}
                            className={`card ${index === currentSlide ? "active" : ""
                              } `}
                          >
                            <div className="d-flex flex-column justify-content-center p-xxl-5 p-xl-4 p-lg-3 p-md-3 p-3">
                              {subObj?.img && (
                                <div className="subscription-img mt-2 mb-2">
                                  <img
                                    src={subObj.img}
                                    alt={subObj?.name}
                                    style={{
                                      width: "100%",
                                      height: "180px",
                                      objectFit: "contain",
                                      borderRadius: "12px"
                                    }}
                                  />
                                </div>
                              )}
                              <div>
                                <h3 className="sub-title">
                                  Subscription Details/ {subObj?.name}
                                </h3>
                              </div>

                              <div className="price">
                                ₹<span>{subObj?.price}</span>
                              </div>

                              <div
                                style={{
                                  fontSize: "16px",
                                  color: "grey",
                                }}
                              >
                                ₹
                                <span
                                  style={{ textDecoration: "line-through" }}
                                >
                                  {subObj?.discountPrice}
                                </span>
                              </div>

                              <hr style={{ color: "#fff;", opacity: 1 }} />

                              <div>
                                <div className="key-main">
                                  <span className="key-title">Key Features</span>
                                </div>
                                <div
                                  className="key-features-content"
                                  dangerouslySetInnerHTML={{ __html: subObj?.keyFeatures || '' }}
                                  style={{
                                    maxHeight: expandedCards[subObj.subscriptionMasterId] ? 'none' : '62px',
                                    overflow: 'hidden',
                                    fontSize: '14px',
                                    lineHeight: '1.4',
                                    position: 'relative',
                                    transition: 'max-height 0.3s ease'
                                  }}
                                />

                                {/* Gradient overlay for collapsed state */}
                                {!expandedCards[subObj.subscriptionMasterId] && (
                                  <div style={{
                                    position: 'absolute',
                                    bottom: '60px',
                                    left: '16px',
                                    right: '16px',
                                    height: '150px',
                                    pointerEvents: 'none'
                                  }} />
                                )}

                                {/* Show More/Less Button */}
                                {subObj?.keyFeatures && subObj.keyFeatures.length > 100 && (
                                  <button
                                    onClick={() => toggleExpand(subObj.subscriptionMasterId)}
                                    style={{
                                      background: 'none',
                                      border: 'none',
                                      color: '#007bff',
                                      cursor: 'pointer',
                                      padding: '5px 0',
                                      fontSize: '14px',
                                      marginTop: '8px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      fontWeight: '500'
                                    }}
                                  >
                                    {expandedCards[subObj.subscriptionMasterId] ? (
                                      <>
                                        <span style={{ marginRight: '5px' }}>▼</span>
                                        Show Less
                                      </>
                                    ) : (
                                      <>
                                        <span style={{ marginRight: '5px' }}>▶</span>
                                        Show More
                                      </>
                                    )}
                                  </button>
                                )}
                              </div>

                              <div className="mt-2">
                                <Button
                                  className="sub-btn"
                                  onClick={() => handleSubscribe(subObj)}
                                >
                                  Subscribe Now
                                </Button>
                              </div>
                            </div>
                          </Card>
                        );
                      })}
                  </Slider>
                </Col>
              </Row>
            </Container>
          </div>
        )}

        <div className="msection">
          <Container>
            <Row>
              <Col xs={12}>
                <div className="sectionMainTitle">
                  <span className="sectionTitle">Our Partners</span>
                </div>
              </Col>
            </Row>

            <Row className="mt-2 mb-2">
              <Col>
                <OffersList />
              </Col>
            </Row>

            <div className="partner-content">
              <Row>
                {partnerList?.partners?.length > 0 ? (
                  partnerList?.partners
                    ?.map((partnerObj) => {
                      return (
                        <Col
                          key={partnerObj?.partnerId}
                          md={3}
                          xs={6}
                          className="mt-2"
                        >
                          <Card
                            style={{ cursor: "pointer", height: "100%" }}
                            onClick={() => handlePartnerClick(partnerObj)}
                            className="partnerMainCard"
                          >
                            <Card.Body className="partnerCardContent">
                              <div className="partnerImgSection">
                                <img
                                  className="img-fluid"
                                  src={partnerObj?.partnerPhoto || defaultPhoto}
                                  alt="google_store_img"
                                />
                                <div
                                  className="favorite-icon"
                                  onClick={(e) => toggleFavorite(partnerObj, e)}
                                  style={{
                                    position: "absolute",
                                    top: "-7px",
                                    right: "-80px",
                                    cursor: "pointer",
                                    zIndex: 1,
                                  }}
                                >
                                  {partnerObj?.isFavourite === 1 ? (
                                    <FaHeart color="red" size={20} />
                                  ) : (
                                    <FaRegHeart color="black" size={20} />
                                  )}
                                </div>
                              </div>
                              <div className="productSectionTitle mt-lg-2">
                                {partnerObj?.partnerName}
                              </div>
                            </Card.Body>
                          </Card>
                        </Col>
                      );
                    })
                    .slice(0, 8)
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      backgroundColor: "#f0f7ff",
                      borderRadius: "5px",
                      lineHeight: "20px",
                      padding: "20px",
                      color: "#024089",
                      marginTop: "20px",
                    }}
                  >
                    No Partner Found
                  </div>
                )}
              </Row>
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <span
                onClick={() => navigate("/partners")}
                style={{
                  color: "#ffffff",
                  marginTop: "10px",
                  padding: "10px 24px",
                  borderRadius: "30px",
                  fontWeight: 600,
                  background: "#024089",
                  fontSize: "18px",
                  letterSpacing: "0.5px",
                  userSelect: "none",
                  textAlign: "center",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                }}
              >
                Show More
              </span>
            </div>
          </Container>
        </div>

        <div className="msection">
          <Container>
            <Row>
              <Col xs={12}>
                <div className="sectionMainTitle">
                  <span className="sectionTitle">Blog</span>
                </div>
              </Col>
            </Row>
            <div className="blog-content">
              {loadingBlogs ? (
                <div style={{ textAlign: "center", padding: "40px" }}>
                  <Loader />
                </div>
              ) : blogList.length > 0 ? (
                <>
                  <Row>
                    {blogList
                      ?.map((item) => {
                        return (
                          <Col
                            key={item.blogId}
                            lg={isMobile && isRespon ? 12 : 4}
                            md={isMobile && isRespon ? 12 : 6}
                            className="mt-2"
                          >
                            <Card
                              style={{ cursor: "pointer" }}
                              className="blogMainCard"
                            >
                              <div className="blogImgSection">
                                <img
                                  className="img-fluid w-100"
                                  src={item.blogImg}
                                  alt={item.blogTitle}
                                  onError={(e) => {
                                    e.target.src = defaultBlogImg;
                                  }}
                                />
                              </div>
                              <Card.Body className="blogCardContent">
                                <div className="blogT mt-lg-2">
                                  <h6>
                                    <a
                                      href={item.blogLink}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ color: "inherit", textDecoration: "none" }}
                                    >
                                      {item.blogTitle}
                                    </a>
                                  </h6>
                                  <p className="blogP">{item.blogSubtitle}</p>
                                  <p>
                                    <span className="readMoreText">
                                      <a
                                        style={{
                                          textDecoration: "none",
                                          color: "#1e293b",
                                        }}
                                        href={item.blogLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        Read More
                                      </a>
                                    </span>
                                    <FaArrowRightLong />
                                  </p>
                                </div>
                              </Card.Body>
                            </Card>
                          </Col>
                        );
                      })
                      .slice(0, isMobile ? 1 : 6)}
                  </Row>
                  <div className="showAllBlogs">
                    <a
                      href="https://blog.smaartcard.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Show All <FaArrowRightLong />
                    </a>
                  </div>
                </>
              ) : (
                <div style={{ textAlign: "center", padding: "40px", color: "#666" }}>
                  No blog posts available at the moment.
                </div>
              )}
            </div>
          </Container>
        </div>

        <div className="msection">
          <Container>
            <Row>
              <Col xs={12}>
                <div className="sectionMainTitle">
                  <span className="sectionTitle">FAQs</span>
                </div>
              </Col>
            </Row>
            <div className="blog-content">
              <Row>
                <Col xs={12}>
                  {faqData?.map((item, index) => {
                    return (
                      <Accordian
                        key={item?.faqId}
                        header={item?.question}
                        body={item?.answer}
                      />
                    );
                  })}
                </Col>
              </Row>
            </div>
          </Container>
        </div>

        <div id="franchise" className="msection">
          <Container>
            <div className="joinSection">
              <Row>
                <Col lg={{ span: 8, offset: 2 }} xs={12}>
                  <div className="franchiseSection text-center">
                    Join our franchise today and turn your entrepreneurial
                    dreams into reality!
                  </div>
                </Col>
                <Col
                  lg={{ span: 6, offset: 3 }}
                  xs={{ span: 11, offset: 1 }}
                  className="mt-lg-3 mt-2"
                >
                  <Row>
                    <Col lg={12} xs={4}>
                      <Button
                        onClick={handleEmailFranchise}
                        className="franchiseBtn"
                      >
                        Join as franchise or partner
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
      </div>

      <Footer />
    </HomePageContainer>
  );
};

export default HomePage;
